import { LineChart, LineChartProps } from '../../../../renderers/line-chart/line-chart.component';
import { PUDO_TRANSACTION_VOLUME_LINE_CHART_DEFINITION } from './pudo-transaction-volume-line-chart.definition';
import { PUDO_TRANSACTION_VOLUME_LINE_CHART_MOCK_DATA } from './pudo-transaction-volume-line-chart.mock';

export const PudoTransactionVolumeLineChart = (props: LineChartProps) => (
    <LineChart
        {...props}
        showArea
    />
);

PudoTransactionVolumeLineChart.definition = PUDO_TRANSACTION_VOLUME_LINE_CHART_DEFINITION;
PudoTransactionVolumeLineChart.mockData = PUDO_TRANSACTION_VOLUME_LINE_CHART_MOCK_DATA;
